<template>
	<div class="main-content">
		<contactItem   
		v-for="contact in contacts"
		v-bind:key="contact.uid"
		v-bind:contact="contact"
		@jump-to-profile="$emit('jump-to-profile',contact.uid)"
		/>
	</div>
</template>

<script>
// @ is an alias to /src
import contactItem from "@/components/contactItem.vue"

export default {
	name: 'Contact',
	components: {
		contactItem
	},
	watch: {
        '$store.state.contacts': {
            handler: function(newer, older) { 
                this.contacts=newer;
            },
            deep: true
        }
    },
	data:function(){
		return {
			contacts:[]
		}
	},
	mounted(){
		this.contacts=this.$store.state.contacts;
		if(this.$store.state.contacts.length === 0){
			this.$socket.emit('loadContacts',{contacts:this.$store.state.contactIndex});
		}
	}
}
</script>

<style>

</style>
